const local = {
	verifynew: "http://localhost:8000/cbre/api/verifynew",
	startfresh: "http://localhost:8000/cbre/api/startfresh",
	verifycontinue: "http://localhost:8000/cbre/api/verifycontinue",
	getSubmissionDetails: "http://localhost:8000/cbre/api/getSubmissionDetails",
	bypassSubmission: "http://localhost:8000/cbre/api/bypassSubmission",
	authenticate: "http://localhost:8000/authenticate",
	statusupdate: "http://localhost:8000/cbre/api/statusupdate",
	utilityButton: "https://session.diro.live/server/#/client/?buttonid=O.US-Vi2KcW-l2U&trackid=",
	bankButton: "https://session.diro.live/server/#/client/?buttonid=O.US-Vi2KcW-FH7&trackid=",
	apikey: "7f30ec7be34e9a07d9ff24d970ad8ad5", //cbre@diro.io -stage2
	// apikey: "69a20a9fc824e2a8f41605f107f43841", //cbre@diro.io -stage2
	feedbackUrl: "http://localhost:8000/cbre/api/sendsupportemail",
	sentryDSN: "https://4df7c2cf900c48fa4505ccabfd720ff5@o1042621.ingest.sentry.io/4506834669076480",
	greylog: "https://utils.diro.live/logs",
	environment: "stage2",
};
const stage1 = {
	verifynew: "https://api1.diro.me/cbre/api/verifynew",
	startfresh: "https://api1.diro.me/cbre/api/startfresh",
	verifycontinue: "https://api1.diro.me/cbre/api/verifycontinue",
	statusupdate: "https://api1.diro.me/cbre/api/statusupdate",
	utilityButton: "https://verification.diro.live/?buttonid=O.US-Vi2KcW-l2U&trackid=",
	bankButton: "https://verification.diro.live/?buttonid=O.US-Vi2KcW-FH7&trackid=",
	apikey: "7f30ec7be34e9a07d9ff24d970ad8ad5", //cbre@diro.io -stage2
	feedbackUrl: "https://api1.diro.me/cbre/api/sendsupportemail",
	sentryDSN: "https://d58e507e9f384fb982d4c84dc7b94fc1@o4505041099030528.ingest.sentry.io/4505265794252800",
	environment: "stage1",
};
const stage2 = {
	verifynew: "https://api2.diro.live/cbre/api/verifynew",
	startfresh: "https://api2.diro.live/cbre/api/startfresh",
	verifycontinue: "https://api2.diro.live/cbre/api/verifycontinue",
	getSubmissionDetails: "https://api2.diro.live/cbre/api/getSubmissionDetails",
	bypassSubmission: "https://api2.diro.live/cbre/api/bypassSubmission",
	authenticate: "https://api2.diro.live/authenticate",
	statusupdate: "https://api2.diro.live/cbre/api/statusupdate",
	// utilityButton: "https://session.diro.live/server/#/client/?buttonid=O.US-Vi2KcW-l2U&trackid=",
	utilityButton: "https://verification.diro.live/?buttonid=O.US-Vi2KcW-l2U&trackid=",
	// bankButton: "https://session.diro.live/server/#/client/?buttonid=O.US-Vi2KcW-FH7&trackid=",
	bankButton: "https://verification.diro.live/?buttonid=O.US-Vi2KcW-FH7&trackid=",
	apikey: "7f30ec7be34e9a07d9ff24d970ad8ad5", //cbre@diro.io -stage2
	feedbackUrl: "https://api2.diro.live/cbre/api/sendsupportemail",
	sentryDSN: "https://4df7c2cf900c48fa4505ccabfd720ff5@o1042621.ingest.sentry.io/4506834669076480",
	greylog: "https://utils.diro.live/logs",
	environment: "stage2",
};

const prod = {
	verifynew: "https://api.diro.io/cbre/api/verifynew",
	startfresh: "https://api.diro.io/cbre/api/startfresh",
	verifycontinue: "https://api.diro.io/cbre/api/verifycontinue",
	statusupdate: "https://api.diro.io/cbre/api/statusupdate",
	getSubmissionDetails: "https://api.diro.io/cbre/api/getSubmissionDetails",
	bypassSubmission: "https://api.diro.io/cbre/api/bypassSubmission",
	utilityButton: "https://verification.diro.io/?buttonid=O.US-ay2FKk-uk1&trackid=",
	bankButton: "https://verification.diro.io/?buttonid=O.US-ay2FKk-oFP&trackid=",
	apikey: "798ef3748a86cbd6e6705c5c9ba912d2", //cbre.prod@diro.io - prod
	feedbackUrl: "https://api.diro.io/cbre/api/sendsupportemail",
	sentryDSN: "https://2e7035e6d9e4429aa7082e7b915ba68e@o305199.ingest.sentry.io/4505029391155200",
	greylog: "https://logs.diro.live/logs",
	environment: "prod",
};
const testprod = {
	verifynew: "https://api.diro.io/cbretest/api/verifynew",
	startfresh: "https://api.diro.io/cbretest/api/startfresh",
	verifycontinue: "https://api.diro.io/cbretest/api/verifycontinue",
	statusupdate: "https://api.diro.io/cbretest/api/statusupdate",
	bypassSubmission: "https://api.diro.io/cbretest/api/bypassSubmission",
	getSubmissionDetails: "https://api.diro.io/cbretest/api/getSubmissionDetails",
	utilityButton: "https://verification.diro.io/?buttonid=O.US-hjr11i-QvT&trackid=",
	bankButton: "https://verification.diro.io/?buttonid=O.US-hjr11i-JkQ&trackid=",
	apikey: "69a20a9fc824e2a8f41605f107f43841", // cbre@diro.io - prod
	feedbackUrl: "https://api.diro.io/cbretest/api/sendsupportemail",
	sentryDSN: "https://2e7035e6d9e4429aa7082e7b915ba68e@o305199.ingest.sentry.io/4505029391155200",
	greylog: "https://utils.diro.live/logs",
	environment: "testprod",
};
const preprod = {
	verifynew: "https://api.diro.io/cbredemo/api/verifynew",
	startfresh: "https://api.diro.io/cbredemo/api/startfresh",
	verifycontinue: "https://api.diro.io/cbredemo/api/verifycontinue",
	statusupdate: "https://api.diro.io/cbredemo/api/statusupdate",
	utilityButton: "https://diro.io/verification?buttonid=O.US-hjr11i-QvT&trackid=",
	bankButton: "https://diro.io/verification?buttonid=O.US-hjr11i-JkQ&trackid=",
	apikey: "69a20a9fc824e2a8f41605f107f43841", // cbre@diro.io - prod
	feedbackUrl: "https://api.diro.io/cbredemo/api/sendsupportemail",
	sentryDSN: "https://2e7035e6d9e4429aa7082e7b915ba68e@o305199.ingest.sentry.io/4505029391155200",
	environment: "preprod",
};
export { prod };
export { stage2 as env };
export { testprod };
export { preprod };
export { stage1 };
